// extracted by mini-css-extract-plugin
module.exports = {"pane":"BoutiqueUserPane-pane-8a27"};